import { render, staticRenderFns } from "./KnProductItem.vue?vue&type=template&id=7db94cf8&"
import script from "./KnProductItem.vue?vue&type=script&lang=js&"
export * from "./KnProductItem.vue?vue&type=script&lang=js&"
import style0 from "./KnProductItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports